import { withStyles } from '@mui/styles';
import React, { useState, useEffect } from 'react';
import colors from '../../../../../src/utils/colors';
import clsx from 'clsx';
import { Box, Typography } from '@mui/material';
import CircularProgress from '@mui/material/CircularProgress';

import MedicalServicesIcon from "@mui/icons-material/MedicalServices";
import VerifiedUserIcon from "@mui/icons-material/VerifiedUser";
import LanguageIcon from "@mui/icons-material/Language";
import LocationOnIcon from "@mui/icons-material/LocationOn";
import PersonIcon from "@mui/icons-material/Person";
import BadgeIcon from "@mui/icons-material/Badge";
import OpenInNewIcon from "@mui/icons-material/OpenInNew";
import { fetchProviderLocationsV2 } from '../../../dynamicHome/components/FindCare/FindCareNew/providers-api';


const styles = (theme) => ({
    container: {
        padding: 0,
    },    
    

    locationContainer: {
    backgroundColor: colors.WHITE,
    padding: theme.spacing(3),
    borderRadius: theme.spacing(1),
    width: '100',
    border:`0.5px solid rgba(110, 110, 110, 0.3)`,
    display:'flex',
    alignItems:'center',
    marginTop: `${theme.spacing(2)}`,

    // boxShadow: '0px 2px 4px -2px rgba(16, 24, 40, 0.06), 0px 4px 8px -2px rgba(16, 24, 40, 0.1)',

    },
      text:{
        fontFamily: 'Inter',
        fontStyle: 'normal',
        color: colors.BLACK_B500,
        fontWeight: 400,
        fontSize: 14,
        lineHeight: '24px',
      },
      address: {
        fontSize: 16,
        color: 'rgb(102, 112, 133)',
      },
      label: {
        fontSize: 16,
        fontWeight: 500,
        display:'flex',
        alignItems:'center',
        margin: `${theme.spacing(1)} 0px`,
        color:'rgb(102, 112, 133)',
      },
      heading: {
        fontWeight: 600,
        fontSize: 18,
      },
      link: {
        fontSize: 15,
        color: colors.BLUE,
        textDecoration: 'none',
        display:'flex',
        flexDirection:'row',
        justifyContent:'flex-start',
        alignItems:'center'
      },
      linkIcon: {
        alignSelf:'center',
        fill:'rgb(102, 112, 133)',
        fontSize: 15,
        fill: colors.BLUE,
        color: colors.BLUE,
        marginLeft: theme.spacing(1),
      },
      distance: {
        color: 'rgb(102, 112, 133)',
      },
      distanceTitle: {
        fontWeight: 500,
        display:'flex',
        margin: `${theme.spacing(1)} 0px`,
      },
      name:{
        fontWeight: 500,
        fontSize:20,
      },
      nameContainer:{
        marginBottom:theme.spacing(2),
        display:'flex',
        alignItems:'center'
      },
      avatarContainer:{
        width:40,
        height:40,
        backgroundColor:colors.RED,
        borderRadius: 100,
        display:'flex',
        alignItems:'center',
        justifyContent:'center',
        marginRight:theme.spacing(2),
      },
      avatar:{
        color: colors.WHITE,
        fontSize: '100%',
      },
      img:{
        alignSelf:'center',
        // height: 26,
        // width: 26,
        fontSize:'1.5rem',
        marginRight: theme.spacing(1),
        fill:'rgb(102, 112, 133)',
      },
      locationHeading:{
        marginTop: `${theme.spacing(2)}`,
      },
      loadingContainer: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        padding: theme.spacing(3),
      },
  });



const ProviderDetails = ({ classes, data, ...props }) => {
    const [locations, setLocations] = useState([]);
    const [loadingLocations, setLoadingLocations] = useState(false);

    // Extract PCP data from props
    const providerName = data?.providerName?.value || '-';
    const specialty = data?.specialty?.value || '-';
    const qualification = data?.qualification?.value || '-';
    const languagesSpoken = data?.languagesSpoken?.value || [];
    const gender = data?.gender?.value || '-';
    const npi = data?.npi?.value || '';

    // Format languages for display
    const languageDisplay = Array.isArray(languagesSpoken) && languagesSpoken.length > 0
        ? languagesSpoken.join(', ')
        : '-';

    useEffect(() => {
        const fetchLocations = async () => {
            if (!npi || npi === '-') return;

            setLoadingLocations(true);
            try {
                const response = await fetchProviderLocationsV2(npi, 0, 20, '', '');
                const formattedLocations = (response?.content || []).map(loc => ({
                    addressLine: `${loc.address || ''}, ${loc.city || ''}, ${loc.state || ''} ${loc.postalCode || ''}`,
                    telephoneNumber: loc.telephoneNumber || '',
                    latitude: parseFloat(loc.latitude) || 0,
                    longitude: parseFloat(loc.longitude) || 0,
                }));
                setLocations(formattedLocations);
            } catch (error) {
                console.error('Error fetching provider locations:', error);
                setLocations([]);
            } finally {
                setLoadingLocations(false);
            }
        };

        fetchLocations();
    }, [npi]);

    function getInitials(fullName) {
        if (!fullName || fullName === '-') return '';
        const names = fullName.split(' ');
      
        if (names.length >= 2) {
            const firstNameInitial = names[0].charAt(0).toUpperCase();
            const lastNameInitial = names[names.length - 1].charAt(0).toUpperCase();
            return `${firstNameInitial}${lastNameInitial}`;
        } else if (names.length === 1) {
            return names[0].charAt(0).toUpperCase();
        } else {
            return '';
        }
    }

    return (
        <Box className={classes.container}>
            <Box className={classes.nameContainer}>
                <Box className={classes.avatarContainer}>
                    <Typography variant="h6" className={clsx([classes.text, classes.avatar])}>
                        {getInitials(providerName)}
                    </Typography>
                </Box>
                
                <Typography variant="h6" className={clsx([classes.text, classes.name])}>
                    {providerName}
                </Typography>
            </Box>

            {specialty !== '-' && (
                <Typography variant="h6" className={clsx([classes.text, classes.label])}>
                    <MedicalServicesIcon className={classes.img} /> {specialty}
                </Typography>
            )}

            {qualification !== '-' && (
                <Typography variant="h6" className={clsx([classes.text, classes.label])}>
                    <VerifiedUserIcon className={classes.img} /> {qualification}
                </Typography>
            )}

            {languageDisplay !== '-' && (
                <Typography variant="h6" className={clsx([classes.text, classes.label])}>
                    <LanguageIcon className={classes.img} /> {languageDisplay}
                </Typography>
            )}

            {gender !== '-' && (
                <Typography variant="h6" className={clsx([classes.text, classes.label])}>
                    <PersonIcon className={classes.img} /> {gender}
                </Typography>
            )}

            {npi !== '-' && (
                <Typography variant="h6" className={clsx([classes.text, classes.label])}>
                    <BadgeIcon className={classes.img} /> {npi}
                </Typography>
            )}

            {npi !== '-' && (
                <>
                    <Typography variant="h6" className={clsx([classes.text, classes.heading, classes.locationHeading])}>
                        {'Locations'}
                    </Typography>

                    {loadingLocations ? (
                        <Box className={classes.loadingContainer}>
                            <CircularProgress size={24} />
                        </Box>
                    ) : locations.length > 0 ? (
                        locations.map((item, index) => (
                            <Box key={index} className={classes.locationContainer}>
                                <LocationOnIcon className={classes.img} />
                                <Box>
                                    <Typography variant="h6" className={clsx([classes.text, classes.address])}>
                                        {item?.addressLine}
                                    </Typography>

                                    {item?.telephoneNumber && (
                                        <Typography variant="h6" className={clsx([classes.text, classes.distanceTitle])}>
                                            Phone:&nbsp;
                                            <Typography variant="h6" className={clsx([classes.text, classes.distance])}>
                                                {item.telephoneNumber}
                                            </Typography>
                                        </Typography>
                                    )}

                                    {item?.latitude && item?.longitude && (
                                        <a
                                            target="_blank"
                                            rel="noopener noreferrer"
                                            href={`https://maps.google.com/?q=${item.latitude},${item.longitude}`}
                                            className={classes.link}
                                        >
                                            {'View Map  '}
                                            <OpenInNewIcon className={classes.linkIcon} />
                                        </a>
                                    )}
                                </Box>
                            </Box>
                        ))
                    ) : (
                        <Typography variant="h6" className={clsx([classes.text, classes.address])}>
                            No locations available
                        </Typography>
                    )}
                </>
            )}
        </Box>
    );
};

export default withStyles(styles, { withTheme: true })(ProviderDetails);

